import { IPressableProps, Pressable } from 'native-base';
import React from 'react';

import Blur from 'app/components/Blur';
import { tID } from 'app/services/TestHelper';

export type BlurOverlayProps = IPressableProps & {
  isBlurred?: boolean;
  onPress?: () => void;
};

export default function BlurOverlay({ isBlurred = false, onPress, ...props }: BlurOverlayProps) {
  return (
    <Pressable
      {...props}
      bg={isBlurred ? undefined : 'rgba(0, 0, 0, 0.3)'}
      h="full"
      left={0}
      position="absolute"
      role="presentation"
      testID={tID('BlurOverlay')}
      top={0}
      w="full"
      onPress={onPress}
    >
      {isBlurred && <Blur style={{ height: '100%', width: '100%' }} />}
    </Pressable>
  );
}
